
// let baseUrl = "http://2.32.63.161:8183/"//上传审核荣露本地
let baseUrl = "https://credit.suzhou.com.cn/" //生产
// let baseUrl = "http://2.46.14.41:8184/xinyidai/"  //生产 /xinyidai/前缀 


// switch (process.env.NODE_ENV) {
//     //注意变量名是自定义的
//     case 'dev':
//         // 是否为测试环境运行
//         if (currentEnv == 1) {
//             // baseUrl = "http://192.168.1.111:8083" // 可更改为联调服务端
//             // baseUrl = "http://192.168.124.160:8083"
//             // baseUrl = "http://192.168.124.60:8083"
//             baseUrl = "http://2.46.5.101:8084"     //生产环境
//             // baseUrl = "http://127.0.0.1:8183"

//         } else {
//             baseUrl = "http://127.0.0.1:8183"  // 生产环境url
//             // baseUrl = "http://2.46.14.41:8183"

//         }
//         break
//     case 'serve':
//         baseUrl = "http://3847953t8e.qicp.vip:29826"
//         break
//     case 'production':
//         baseUrl = "http://2.46.5.101:8084"
//         // baseUrl = "http://127.0.0.1:8183"
//         break
// }


export default baseUrl;